import {PermissionRuleInterface} from 'appShared/interfaces';
import {PermissionRuleCheckStrategiesEnum, PermissionsEnum} from 'appShared/enums';

export class PermissionRulesTrait {
    private constructor() {
    }

    static getUserAccountViewPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmAllAll,
                PermissionsEnum.CrmTradingAccountsAll,
                PermissionsEnum.CrmTradingAccountsViewDetails,
            ],
            strategy
        };
    }

    static getUserViewPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmAllAll,
                PermissionsEnum.CrmUsersAll,
                PermissionsEnum.CrmUsersViewDetails,
            ],
            strategy
        };
    }

    static getClientViewPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmClientsAll,
                PermissionsEnum.CrmClientsViewDetails,
            ],
            strategy
        };
    }

    static getMarketDataFeedAndBundleViewPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                ...PermissionRulesTrait.getMarketDataFeedManagementPermissionRule().permissions,
                ...PermissionRulesTrait.getMarketDataFeedBundleManagementPermissionRule().permissions,
                PermissionsEnum.CrmSubscriptionManagementViewAvailableFeeds
            ],
            strategy
        };
    }

    static getMarketDataFeedAndBundleRemoveBtnViewPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                ...PermissionRulesTrait.getMarketDataFeedManagementPermissionRule().permissions,
                ...PermissionRulesTrait.getMarketDataFeedBundleManagementPermissionRule().permissions,
            ],
            strategy
        };
    }

    static getMarketDataFeedBundleManagementPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmSubscriptionManagementAll,
                PermissionsEnum.CrmSubscriptionManagementManageFeedBundles,
            ],
            strategy
        };
    }

    static getMarketDataFeedManagementPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmSubscriptionManagementAll,
                PermissionsEnum.CrmSubscriptionManagementManageFeeds
            ],
            strategy
        };
    }

    static getTradingPlansViewPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmTradingPlansAll,
                PermissionsEnum.CrmTradingPlansView
            ],
            strategy
        };
    }

    static getCouponsViewPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmCouponsAll,
                PermissionsEnum.CrmCouponsView
            ],
            strategy
        };
    }

    static getCloseoutPlansViewPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmCloseoutPlansAll,
                PermissionsEnum.CrmCloseoutPlansView,
                PermissionsEnum.CrmCloseoutPlansCreate,
                PermissionsEnum.CrmCloseoutPlansEdit,
                PermissionsEnum.CrmCloseoutPlansChangeStatus
            ],
            strategy
        };
    }

    static getCreateCloseoutPlanPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmCloseoutPlansAll,
                PermissionsEnum.CrmCloseoutPlansCreate
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        };
    }

    public static getEditCloseoutPlanPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmCloseoutPlansAll,
                PermissionsEnum.CrmCloseoutPlansEdit
            ],
            strategy
        };
    }

    static getOrderRoutesViewPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmOrderRoutesAll,
                PermissionsEnum.CrmOrderRoutesView
            ],
            strategy
        };
    }

    static getOrderRoutesCreatePermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmOrderRoutesAll,
                PermissionsEnum.CrmOrderRoutesCreate
            ],
            strategy
        };
    }

    static getMarketDataFeedViewPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                ...PermissionRulesTrait.getMarketDataFeedManagementPermissionRule().permissions,
                PermissionsEnum.CrmSubscriptionManagementViewAvailableFeeds
            ],
            strategy
        };
    }

    static getPlatformFrontendManagementPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                ...PermissionRulesTrait.getMarketDataFeedManagementPermissionRule().permissions,
                ...PermissionRulesTrait.getMarketDataFeedBundleManagementPermissionRule().permissions,
                PermissionsEnum.CrmSubscriptionManagementManageTradingPlatforms,
            ],
            strategy
        };
    }

    static getMarketDataFeedMarkupManagementPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmSubscriptionManagementAll,
                PermissionsEnum.CrmSubscriptionManagementManageUserMarkups,
            ],
            strategy
        };
    }

    static getAssignedFeedsToUsersViewPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmSubscriptionManagementAll,
                PermissionsEnum.CrmSubscriptionManagementViewAssignedFeeds,
            ],
            strategy
        };
    }

    static getMarketDataFeedMarkupManagementAncClientUserPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                ...PermissionRulesTrait.getViewClientUsersPermissionRule().permissions,
                ...PermissionRulesTrait.getMarketDataFeedMarkupManagementPermissionRule().permissions,
            ],
            strategy
        };
    }

    static getEditAssignedFeedsToUsersPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmSubscriptionManagementAll,
                PermissionsEnum.CrmSubscriptionManagementEditAssignedFeeds,
            ],
            strategy
        };
    }

    static getAssignFeedsToUsersPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmSubscriptionManagementAll,
                PermissionsEnum.CrmSubscriptionManagementAssignFeedsToUsers,
            ],
            strategy
        };
    }

    static getServiceUserViewPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmSubscriptionManagementAll,
                PermissionsEnum.CrmSubscriptionManagementSetUserSettings,
                PermissionsEnum.CrmSubscriptionManagementViewUserSettings
            ],
            strategy
        };
    }

    static getSesUserSettingsViewPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmSubscriptionManagementAll,
                PermissionsEnum.CrmSubscriptionManagementViewUserSettings
            ],
            strategy
        };
    }

    static getSesUserSettingsManagementPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmSubscriptionManagementAll,
                PermissionsEnum.CrmSubscriptionManagementSetUserSettings,
            ],
            strategy
        };
    }

    static getEventHistoryViewPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmSubscriptionManagementAll,
                PermissionsEnum.CrmSubscriptionManagementViewEventHistory,
            ],
            strategy
        };
    }

    static getMarketDataUsageReportsViewPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmSubscriptionManagementAll,
                PermissionsEnum.CrmSubscriptionManagementViewMarketDataUsageReports,
            ],
            strategy
        };
    }

    static getMarketingReportsViewPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CRMReportsViewMarketingReports
            ],
            strategy
        };
    }

    static getMarketingReportsManagementPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CRMReportsManageMarketingReports
            ],
            strategy
        };
    }

    static getReportsViewPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmReportsAll,
                PermissionsEnum.CrmReportsViewPredefinedReports
            ],
            strategy
        };
    }

    static getViewFeedPricePermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmSubscriptionManagementAll,
                PermissionsEnum.CrmSubscriptionManagementManageFeeds,
                PermissionsEnum.CrmSubscriptionManagementViewFeedPrice,
            ],
            strategy
        };
    }

    static getViewFeedMarkupPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmSubscriptionManagementAll,
                PermissionsEnum.CrmSubscriptionManagementViewMarkups,
            ],
            strategy
        };
    }

    static getSetSubscriptionPricePermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmSubscriptionManagementAll,
                PermissionsEnum.CrmSubscriptionManagementSetSubscriptionPrice,
            ],
            strategy
        };
    }

    static getViewSubscriptionPricePermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmSubscriptionManagementAll,
                PermissionsEnum.CrmSubscriptionManagementViewSubscriptionPrice,
            ],
            strategy
        };
    }

    static getSetFeedMarkupPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmSubscriptionManagementAll,
                PermissionsEnum.CrmSubscriptionManagementSetMarkups,
            ],
            strategy
        };
    }

    static getEntitlementReportViewPermissionRule(
        strategy: PermissionRuleCheckStrategiesEnum = PermissionRuleCheckStrategiesEnum.Union
    ): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmSubscriptionManagementAll,
                PermissionsEnum.CrmSubscriptionManagementViewEntitlementReports
            ],
            strategy
        };
    }

    static getViewAccountsPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmTradingAccountsCreateNew,
                PermissionsEnum.CrmTradingAccountsViewDetails,
                PermissionsEnum.CrmTradingAccountsUpdateDetails,
                PermissionsEnum.CrmCashAccountsCreateNew,
                PermissionsEnum.CrmCashAccountsViewDetails,
                PermissionsEnum.CrmCashAccountsUpdateDetails,
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        };
    }

    static getViewClientDetailsPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmClientsCreateNew,
                PermissionsEnum.CrmClientsViewDetails,
                PermissionsEnum.CrmClientsUpdateDetails
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        };
    }

    static getViewClientRiskParameterAndAssessmentPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmClientsViewRiskParameters,
                PermissionsEnum.CrmClientsUpdateRiskParameters,
                PermissionsEnum.CrmClientsUpdateRiskScore
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        };
    }

    static getViewDocumentsPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmDocumentsCreateNew,
                PermissionsEnum.CrmDocumentsViewDetails,
                PermissionsEnum.CrmDocumentsUpdateDetails
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        };
    }

    static getViewBankAccountsPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmBankAccountsCreateNew,
                PermissionsEnum.CrmBankAccountsViewDetails,
                PermissionsEnum.CrmBankAccountsUpdateDetails
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        };
    }

    static getViewPaymentsPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmPaymentsCreateNewTransfer,
                PermissionsEnum.CrmPaymentsCreateNewDeposit,
                PermissionsEnum.CrmPaymentsCreateNewWithdrawal,
                PermissionsEnum.CrmPaymentsViewDetails,
                PermissionsEnum.CrmPaymentsUpdateDetails
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        };
    }

    static getViewClientUsersPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmUsersCreateNew,
                PermissionsEnum.CrmUsersViewDetails
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        };
    }

    static getViewClientStatusPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [PermissionsEnum.CrmClientsViewStatus, PermissionsEnum.CrmClientsUpdateStatus],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        };
    }

    static getChangeClientStatusPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [PermissionsEnum.CrmClientsUpdateStatus],
            strategy: PermissionRuleCheckStrategiesEnum.Intersect
        };
    }

    static getChangeClientStatusAccountDependencyPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmTradingAccountsCreateNew,
                PermissionsEnum.CrmCashAccountsCreateNew
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Intersect
        };
    }

    static getChangeClientStatusToTerminatedPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmAllAll,
                PermissionsEnum.CrmClientsDelete
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        };
    }

    static getAddDocumentPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [PermissionsEnum.CrmDocumentsCreateNew],
            strategy: PermissionRuleCheckStrategiesEnum.Intersect
        };
    }

    static getAddBankAccountPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [PermissionsEnum.CrmBankAccountsCreateNew],
            strategy: PermissionRuleCheckStrategiesEnum.Intersect
        };
    }

    static getAddAccountPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmTradingAccountsCreateNew
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Intersect
        };
    }

    static getAddClientUserPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmUsersCreateNew
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Intersect
        };
    }

    static getAssignClientAccountRightsPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmClientsUpdateDetails,
                PermissionsEnum.CrmTradingAccountsViewDetails,
                PermissionsEnum.CrmCashAccountsViewDetails
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Intersect
        };
    }

    static getDisableAccountsPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmTradingAccountsUpdateStatus,
                PermissionsEnum.CrmCashAccountsUpdateStatus
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Intersect
        };
    }

    static getUpdatePaymentDetailsPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmPaymentsUpdateDetails
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Intersect
        };
    }

    static getDeletePaymentPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmAllAll,
                PermissionsEnum.CrmPaymentsDelete
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        };
    }

    static getViewCashAccountsPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmCashAccountsViewDetails,
                PermissionsEnum.CrmCashAccountsUpdateDetails,
                PermissionsEnum.CrmCashAccountsCreateNew
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        };
    }

    static getViewTradingAccountsPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmTradingAccountsViewDetails,
                PermissionsEnum.CrmTradingAccountsUpdateDetails,
                PermissionsEnum.CrmTradingAccountsCreateNew
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        };
    }

    static getEditTradingAccountPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmTradingAccountsUpdateDetails
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        };
    }

    static getViewAccountReferenceIdPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CRMAdministrationSuperAdmin
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        };
    }

    static getViewGroupsPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmClientGroupsCreateNewGroup,
                PermissionsEnum.CrmClientGroupsViewClientGroups,
                PermissionsEnum.CrmClientGroupsUpdateGroup
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        };
    }

    static getCreateProductPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmFundProductsAll,
                PermissionsEnum.CrmFundProductsCreateProduct,
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        };
    }

    static getEditProductPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmFundProductsAll,
                PermissionsEnum.CrmFundProductsUpdateProduct,
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        };
    }

    static getViewProductsPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmFundProductsAll,
                PermissionsEnum.CrmFundProductsViewProduct,
                PermissionsEnum.CrmFundProductsCreateProduct,
                PermissionsEnum.CrmFundProductsUpdateProduct,
                PermissionsEnum.CrmFundProductsManagePrices,
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        };
    }

    static getViewProductDetailsPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmFundProductsAll,
                PermissionsEnum.CrmFundProductsViewProduct,
                PermissionsEnum.CrmFundProductsUpdateProduct,
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        };
    }

    static getManageProductPricesPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmFundProductsAll,
                PermissionsEnum.CrmFundProductsManagePrices,
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        };
    }

    static getViewOrdersPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmFundOrdersAll,
                PermissionsEnum.CrmFundOrdersView
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        };
    }

    static getUpdateOrderDetailsPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [
                PermissionsEnum.CrmFundOrdersAll,
                PermissionsEnum.CrmFundOrdersUpdate
            ],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        };
    }

    static getViewPaymentsBulkPermissionRule(): PermissionRuleInterface {
        return {
            permissions: [PermissionsEnum.CrmPaymentsAll, PermissionsEnum.CrmPaymentsCreateNewAdjustment],
            strategy: PermissionRuleCheckStrategiesEnum.Union
        };
    }
}
